// extracted by mini-css-extract-plugin
module.exports = {"button":"UserMenu_button__1SZWR","icon":"UserMenu_icon__3G7jS","box":"UserMenu_box__37y9R","title":"UserMenu_title__1t9vJ"};